import {alpha} from '@mui/material/styles';
import {grey} from '@mui/material/colors';

const PRIMARY_MAIN = '#825DFC';

const palette = {
    primary: {
	    main: PRIMARY_MAIN,
        light: '#A79CFF',
        dark: '#694ACE'
    },
    secondary: {
	    main: grey[500],
        light: grey[400],
        dark: grey[600],
        hover: grey[100],
        selected: grey[200],
        focus: grey[300],
        focusVisible: grey[300],
        outlineBorder: grey[400]
    },
    action: {
        active: alpha('#000000', 0.32),
        disabled: alpha('#FFFFFF', 0.15),
        hover: alpha(PRIMARY_MAIN, 0.04),
        focusVisible: alpha(PRIMARY_MAIN, 0.10)
    },
    elevation: {
        outlined: '#E0E0E0'
    }
};
  
export default palette;
